import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Http } from '@angular/http';
import { PlayPage } from '../play/play'; 
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-readstory',
  templateUrl: 'readstory.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class ReadstoryPage {
  story_so_far:string;
  book_title:string;
  book_author:string;

  constructor(public functions: Functions, public http: Http, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);

    this.getBookTitleAndAuthor();
    this.getStorySoFar();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  getBookTitleAndAuthor(){
    this.translate.get('book_'+this.functions.getIdCurrentBook()).subscribe(value => { this.book_title = value;});
    this.translate.get('book_'+this.functions.getIdCurrentBook()+'_author').subscribe(value => { this.book_author = value;});
  }
  
  getStorySoFar(){
    var wholeBook="";

    this.http.get('assets/data/book_'+this.functions.getIdCurrentBook()+'.txt').subscribe(data=>{
      let obj = data['_body'];
      this.story_so_far="";
      
      wholeBook=this.functions.normalizeBookTextForShannonMode(obj);
        
      if (!this.functions.isGameModeShannonReverse()) {
        wholeBook=wholeBook.slice(0, this.userdataModel.getBookmarkLetter());
        if (!this.userdataModel.isBookComplete(this.functions.getIdCurrentBook()) && wholeBook!="") {
          wholeBook=wholeBook+"...";
        }
      }else{
        wholeBook=wholeBook.slice(this.userdataModel.getBookmarkLetter()+1,this.userdataModel.getIndexLastCharacterInBookOfBook(this.functions.getIdCurrentBook())+1);

        if (!this.userdataModel.isBookComplete(this.functions.getIdCurrentBook()) && wholeBook!="") {
          wholeBook="..."+wholeBook;
        }
      }
      this.story_so_far = wholeBook;
    });
  }

  goBack(){
    this.navCtrl.pop();
  }

  goToPlay(){  
    this.navCtrl.push(PlayPage, {});
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/readstory/readstory.ts